// BR 巴西逻辑
// 经营概览、订单转化：新增板块，占位组件单独渲染，不在此 transformer 中
// usersAndConversion：暂不使用，等待后续处理

import promotion from './promotion.js'
import menu from './menu.js'
import users from './users.js'
import service from './service.js'
import { intersection } from 'lodash'

// 敏感指标 - 与服务端约定脱敏后不会下发下列指标
export const hypersensitiveIndicators = [
  'onlineDurationAverage',
  'connectivity',
  'preSetBusinessHours',
  'peakOnlineDuration',
  'onlineRateDuringPeakHours',
]

// 是否展示指标全集（高权限用户）
export const checkIsFullIndicators = function (indicators = []) {
  return intersection(indicators, hypersensitiveIndicators).length > 0
}

/**
 *
 * @param {Boolean=} isDesensitized 是否脱敏并展示全部数据，默认false
 * @returns
 */
const ALL_TRANSFORMERS_BR = {
  promotion, // 营销
  service, // 服务
  menu, // 菜品
  users, // 用户
  // online, 在线：删除（已合并到“服务诊断”模块里）
}

export default function transformerBR(data = {}, direction = 'vertical') {
  const results = []
  const cardsList = data.cards
  const dateToWeek = data.dateToWeek
  let isFullResult = true
  for (const cardName in ALL_TRANSFORMERS_BR) {
    const curCard = cardsList?.[cardName]
    const curUtils = ALL_TRANSFORMERS_BR[cardName]
    if (curUtils) {
      // 无权限用户 chartData 返回空。特例：菜单部分数据结构不同且暂无权限限制
      isFullResult = isFullResult && Boolean(curCard?.chartData || curCard?.key === 'menu')

      if (curCard?.chartData || curCard?.key === 'menu') {
        const isFullIndicator =
          curCard?.key === 'service'
            ? checkIsFullIndicators((curCard?.indicators || []).map(i => i.key))
            : true

        const rst = curUtils(curCard, dateToWeek, cardName, direction, isFullIndicator)
        results.push(rst)
      }
    } else {
      console.warning(`${cardName} 未成功获取，请检查命名是否正确。`)
    }
  }

  return {
    results,
    isFullResult,
  }
}
